<template>
  <div :class="openNote_Loading ? 'disable mb-3' : 'mb-3'">
    <div class="p-2 rounded border mb-3">
      <!-- existing note -->
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="!new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            Title:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="noteData.title"
          />
        </div>
      </div>
      <!-- new note -->
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            Title:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="new_title"
          />
        </div>
      </div>
      <div class="form-group d-flex" style="align-items: center;">
        <div style="width: 10%;">
          <label class="form-label">
            Order #:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="orderData.orderNumber"
          />
        </div>
      </div>
      <div class="form-group d-flex" style="align-items: center;">
        <div style="width: 10%;">
          <label class="form-label">
            Product:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="extraOrderData.product_name"
          />
        </div>
      </div>
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            User:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="extraOrderData.full_name"
          />
        </div>
      </div>
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            Client:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="extraOrderData.client_name"
          />
        </div>
      </div>
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="!new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            Cost:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            readonly
            v-model="extraOrderData.points"
          />
        </div>
      </div>
      <div class="form-group d-flex" style="align-items: center;">
        <div style="width: 10%;">
          <label class="form-label">
            Notes:
          </label>
        </div>
        <div style="width: 90%;">
          <textarea
            class="form-control"
            name=""
            id=""
            cols="30"
            rows="10"
            v-model="newContent"
          ></textarea>
        </div>
      </div>
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="!new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            Existing Notes:
          </label>
        </div>
        <div style="width: 90%;">
          <!-- REPLACED TEXT AREA WITH DIV -->
          <!-- <textarea
            class="form-control"
            name=""
            id=""
            cols="30"
            rows="10"
            readonly
            v-model="noteData.content"
          ></textarea> -->

          <div
            v-html="noteData.content"
            class="border rounded form-control text-area"
          ></div>
          <!-- REPLACED TEXT AREA WITH DIV -->
        </div>
      </div>
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            Reply To Email:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            v-model="reply_to_email"
          />
        </div>
      </div>
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="!new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            From Email:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            v-model="userProfile.email"
          />
        </div>
      </div>
      <!-- new note to email -->
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            To Email:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            v-model="to_email"
          />
        </div>
      </div>
      <!-- existing note to email -->
      <div
        class="form-group d-flex"
        style="align-items: center;"
        v-if="!new_note"
      >
        <div style="width: 10%;">
          <label class="form-label">
            To Email:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            v-model="orderData.email"
          />
        </div>
      </div>
      <div class="form-group d-flex" style="align-items: center;">
        <div style="width: 10%;">
          <label class="form-label">
            CC Email:
          </label>
        </div>
        <div style="width: 90%;">
          <input
            class="form-control"
            type="text"
            name=""
            id=""
            v-model="to_cc_email"
          />
        </div>
      </div>
      <div class="d-flex">
        <div style="width: 50%; position: relative;">
          <button
            type="button"
            class="btn btn-primary mr-2"
            style="position: absolute; right: 0;"
            @click="saveNoteAndEmail"
          >
            SAVE NOTES & EMAIL
          </button>
        </div>
        <div style="width: 50%;">
          <button type="button" class="btn btn-primary ml-2" @click="saveNote">
            SAVE NOTES
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenNote",
  data() {
    return {
      newContent: "",
      reply_to_email: "",
      to_email: "",
      to_cc_email: "",
    };
  },
  watch: {
    "$route.query.note_id": function() {
      console.log(this.$route.query.note_id);
      try {
        if (this.$route.query.note_id === "-1") {
          this.$store.state.orderDetails.new_note = true;
        } else {
          this.$store.state.orderDetails.new_note = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    saveNote() {
      if (this.new_note) {
        // add note
        const addNoteRequest = {
          notes_id: null,
          order_id: this.orderData.orderId,
          supplier_id: this.orderData.supplierId,
          product_id: this.orderData.productId,
          user_id: this.orderData.user_id,
          client_id: this.extraOrderData.client_id,
          content: this.newContent,
          is_note_to_save_with_email: false,
          to_email: this.to_email,
          to_cc_email: this.to_cc_email,
          from_email: this.reply_to_email,
        };

        // clear input fields
        this.newContent = "";
        this.to_email = "";
        this.to_cc_email = "";
        this.reply_to_email = "";

        // api call
        this.$store
          .dispatch("orderDetails/addNote", addNoteRequest)
          .then((data) => {
            alert(data);
            this.$store.dispatch("orderDetails/getCRMNotes", {
              orderId: this.orderData.orderId,
            });
          });
      } else {
        // update note
        const updateNoteRequest = {
          notes_id: this.noteData.notes_id,
          order_id: this.orderData.orderId,
          new_content: this.newContent,
          is_note_to_save_with_email: false,
          to_email: this.orderData.email,
          to_cc_email: this.to_cc_email,
          from_email: this.userProfile.email,
        };

        // clear input fields
        this.newContent = "";
        // this.to_email = "";
        this.to_cc_email = "";
        // this.reply_to_email = "";

        // api call
        this.$store
          .dispatch("orderDetails/updateNote", updateNoteRequest)
          .then((data) => {
            alert(data);
            this.$store.dispatch("orderDetails/getCRMNotes", {
              orderId: this.orderData.orderId,
            });
            this.$store.dispatch("orderDetails/getCRMNote", {
              noteId: this.noteData.notes_id,
            });
          });
      }
    },
    saveNoteAndEmail() {
      if (this.new_note) {
        // add note
        const addNoteRequest = {
          notes_id: null,
          order_id: this.orderData.orderId,
          supplier_id: this.orderData.supplierId,
          product_id: this.orderData.productId,
          user_id: this.orderData.user_id,
          client_id: this.extraOrderData.client_id,
          content: this.newContent,
          is_note_to_save_with_email: true,
          to_email: this.to_email,
          to_cc_email: this.to_cc_email,
          from_email: this.reply_to_email,
        };

        // clear input fields
        this.newContent = "";
        // this.to_email = "";
        this.to_cc_email = "";
        // this.reply_to_email = "";

        // api call
        this.$store
          .dispatch("orderDetails/addNote", addNoteRequest)
          .then((data) => {
            alert(data);
            this.$store.dispatch("orderDetails/getCRMNotes", {
              orderId: this.orderData.orderId,
            });
          });
      } else {
        // update note
        const updateNoteRequest = {
          notes_id: this.noteData.notes_id,
          order_id: this.orderData.orderId,
          new_content: this.newContent,
          is_note_to_save_with_email: true,
          to_email: this.orderData.email,
          to_cc_email: this.to_cc_email,
          from_email: this.userProfile.email,
        };

        // clear input fields
        this.newContent = "";
        this.to_email = "";
        this.to_cc_email = "";
        this.reply_to_email = "";

        // api call
        this.$store
          .dispatch("orderDetails/updateNote", updateNoteRequest)
          .then((data) => {
            alert(data);
            this.$store.dispatch("orderDetails/getCRMNotes", {
              orderId: this.orderData.orderId,
            });
            this.$store.dispatch("orderDetails/getCRMNote", {
              noteId: this.noteData.notes_id,
            });
          });
      }
    },
  },
  computed: {
    new_note() {
      return this.$store.state.orderDetails.new_note;
    },
    noteData() {
      return this.$store.state.orderDetails.NoteData;
    },
    extraOrderData() {
      return this.$store.state.orderDetails.extraOrderInfo;
    },
    orderData() {
      return this.$store.state.orderDetails.orderData;
    },
    openNote_Loading() {
      return this.$store.state.orderDetails.openNote_Loading;
    },
    userProfile() {
      return this.$store.state.user.profile;
    },
    new_title() {
      return this.$store.state.orderDetails.new_title;
    },
  },
  created() {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    const date = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();
    const hours = d.getHours();
    const minutes = d.getMinutes();
    this.$store.state.orderDetails.new_title = `order #: ${
      this.$store.state.orderDetails.orderData.orderNumber
    }  [${months[month]} ${date < 10 ? "0" + date : date}, ${year} ${
      hours < 10 ? "0" + hours : hours
    }:${minutes < 10 ? "0" + minutes : minutes}]`;
    console.log(this.orderData.email);

    this.reply_to_email = "customerservice@divvyengagement.com";
    this.to_email = this.orderData.email;
  },
};
</script>

<style scoped>
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.text-area {
  height: 300px;
  overflow-x: hidden;
  resize: vertical;
  background-color: #eaf1f5;
  opacity: 1;
}
</style>
